import { CardProfileDtoToEntity } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/services/mappers/CardProfileDtoToEntity";
import type { CardProfileDto } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/types/CardProfileDto";
import type { CardProfileEntity } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/types/CardProfileEntity";
import type { ResourcePageDto } from "../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const CardProfileTableDtoMapper = (input: Readonly<ResourcePageDto<CardProfileDto>>): ResourcePageEntity<CardProfileEntity> => {
    return {
        list: input.list ? input.list.map(CardProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
